import React, { useState, useEffect, useCallback } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
//imported
import { FEEDBACKS } from "common/viewContent";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns, { selectRow } from "./Columns";
import AddModal from "components/Modals/AddFaq";
import inputFields from "./inputFields";
import Validation from "./Validation";
import { getFeedbackList,getRegenratedFeedback } from "store/feedback/actions";
import { getLanguageList } from "store/language/actions";
import { Link, useNavigate } from "react-router-dom";
import AiSummaryModal from "../../components/Modals/AiSummaryModal/index"

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { FEEDBACK, loading, totalCount } = useSelector(
    (state) => state?.Feedback
  );
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [addModalShow, setAddModalShow] = useState(false);
  const [feedback, setFeedback] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [viewSummary,setViewSummary]=useState(false)
  const [search_text, setSearch_text] = useState();
  const [summaryData,setSummaryData]=useState()
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });
  const [selectedRows, setSelectedRows] = useState([]);
  //const [fetchFeedback,setFetchFeedback]=useState(false)
  const selectRow = {
    mode: "checkbox",
    clickToSelect: true, 
    selected: selectedRows,
    onSelect: (row, isSelect) => {
      setSelectedRows((prevSelected) => {
        if (isSelect) {
          if (prevSelected.length < 5) {
            return [...prevSelected, row.id]; 
          }
          return prevSelected; 
        } else {
          return prevSelected.filter((id) => id !== row.id); 
        }
      });
    },
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const limitedSelection = rows.slice(0, 5).map((r) => r.id); 
        setSelectedRows(limitedSelection);
      } else {
        setSelectedRows([]); 
      }
    },
    nonSelectable: selectedRows.length >= 5
    ? FEEDBACK.data.filter(row => !selectedRows.includes(row.id)).map(row => row.id) 
    : [],
    hideSelectAll: selectedRows.length >= 5,
  };

  const onCliclNavigate = (id) => {
    navigate(`/admin/feedback/all-feedback/${id}`);
  };

  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
      feedbackStatus:"Completed"
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setFeedback(res);
        }
      };
      dispatch(getFeedbackList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const regnerateFeedback=async()=>{
    const payload = {
      id:selectedRows
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          //setFeedback(res);
         toast.success(res.message)
        }
      };
     dispatch(getRegenratedFeedback({ data: payload, callback }));
     // setFetchFeedback(true)
      setSelectedRows([])
    } catch (error) {
      console.error(error, "<===err");
    }
  }

  useEffect(() => {
    fetchData(filter);
    setcolumns(Columns({ onCliclNavigate, currentPage: filter?.pageNo,pageSize,handleViewSummary}));
   // setFetchFeedback(false)
  }, [filter]);
  const handlePageChange = (pageNumber) => {
    console.log("pageNumber->", pageNumber);
    setCurrentPage(pageNumber);
  };

  const formatFeedbackSummary = (text) => {
    // Replace `**bold**` text with <strong> HTML tags
    text = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
  
    // Split the text into separate paragraphs based on double line breaks
    const paragraphs = text.split("\n\n");
  
    return paragraphs.map((para, index) => <p key={index} dangerouslySetInnerHTML={{ __html: para.replace(/\n/g, "<br/>") }} />);
  };

  const handleViewSummary=(summary)=>{
    setSummaryData(formatFeedbackSummary(summary?.ai_analysis||"No summary available"))
    setViewSummary(true)
  }

  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
    });
  };

  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
    }));
    setSearch_text("");
  };

  return (
    <>
    {viewSummary&&(
      <AiSummaryModal show={viewSummary}
      handleClose={() => setViewSummary(false)}
      title={"Ai Genrated  Summary"}
      summaryData={summaryData}
      />
    )}
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={FEEDBACKS.CURRENT_MODULE} />

      <section className="section">
        <div className="section-header">
          <h1>{FEEDBACKS.CURRENT_MODULE}</h1>

          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{FEEDBACKS.CURRENT_MODULE} </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header d-flex align-items-center gap-10">
                  <h2 className="section-title">{FEEDBACKS.TOP_CONTENT}</h2>
                  <button
                    className="btn btn-primary "
                    style={{ fontSize: "0.9rem" }} 
                    onClick={() => regnerateFeedback()}
                    disabled={selectedRows.length < 2}
                  >
                   Group Ai Summarization
                  </button>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header">
                    <div className="col-lg-4 col-sm-12 col-md-12 my-2 px-0">
                      <input
                        className="form-control"
                        name="search_text"
                        onChange={(e) => setSearch_text(e.target.value)}
                        value={search_text}
                        placeholder="Search using name, email..."
                      />
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {/* <div className="col-6">
                <div className="card-header d-flex justify-content-end align-items-center">
                  <button
                    className="btn btn-primary"
                    onClick={() => setAddModalShow(true)}
                  >
                    Add Feedna
                  </button>
                </div>
              </div> */}
              {/* {filter.languageId && (
                <div className="container">
                  <div className="col-6">
                    <FormikForm
                      initialValues={{ select: filter.languageId }}
                      // validationSchema={Validation}
                      onSubmit={handleFilterForm}
                      loading={loading}
                      inputFields={InputFieldsForSearch}
                      // submitting={null}
                      buttonText={"Search"}
                      // is_block={true}
                      col={6}
                      // is_passwordHide={false}
                    />
                  </div>
                </div>
              )} */}
            </div>
          </div>
          {!loading && FEEDBACK?.data?.length > 0 && (
            <Table
              data={FEEDBACK.data}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handlePageChange}
              totalCount={totalCount}
              filter={filter}
              selectRow={selectRow}
            />
          )}
          {!loading && FEEDBACK?.length === 0 && (
            <p style={{ textAlign: "center" }}>No FeedBack Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
